export enum DrawerPositionEnum {
  Left = 'LEFT',
  Right = 'RIGHT',
}
